import { render, staticRenderFns } from "./Wilayah.vue?vue&type=template&id=298696a2&"
import script from "./Wilayah.vue?vue&type=script&lang=js&"
export * from "./Wilayah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports